import React, { useState } from 'react';
import API from '../../api/axios';
import './Admin.css';

export default function AdminBillingResyncPage() {
    const [txRef, setTxRef] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const handleResync = async () => {
        setError(null);
        setResult(null);
        if (!txRef.trim()) {
            setError('Enter a tx_ref first — find it in your Flutterwave dashboard under Transactions.');
            return;
        }
        try {
            setLoading(true);
            const res = await API.post('/api/admin/billing/resync', { tx_ref: txRef.trim() });
            setResult(res.data);
        } catch (err) {
            setError(err.response?.data?.error || 'Could not resync this transaction.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-page">
            <header className="admin-header">
                <h1>Resync Subscription</h1>
            </header>

            <div style={{ padding: '0 16px' }}>
                <p style={{ color: '#666', fontSize: 14, marginBottom: 16 }}>
                    Use this when a user says they paid but can't access what they
                    paid for. Find the transaction's <code>tx_ref</code> in your
                    Flutterwave dashboard (Transactions tab), paste it below, and
                    this will re-verify the payment directly with Flutterwave and
                    activate their subscription.
                </p>

                {error && <div className="donate-error" style={{ margin: '0 0 16px' }}>{error}</div>}
                {result && (
                    <div style={{
                        background: '#eafaf1', color: '#1e8449', padding: 14,
                        borderRadius: 8, marginBottom: 16, fontSize: 14, lineHeight: 1.6,
                    }}>
                        <strong>✅ {result.message}</strong><br />
                        User: {result.user_email}<br />
                        Plan: {result.tier} ({result.duration})<br />
                        Active until: {new Date(result.current_period_end).toLocaleDateString()}
                    </div>
                )}

                <input
                    type="text"
                    placeholder="e.g. godly-a1b2c3d4-1719000000"
                    value={txRef}
                    onChange={(e) => setTxRef(e.target.value)}
                    style={{
                        width: '100%', padding: 12, marginBottom: 12,
                        border: '1px solid #e5e5ea', borderRadius: 8, fontSize: 15,
                        fontFamily: 'monospace',
                    }}
                />

                <button
                    onClick={handleResync}
                    disabled={loading}
                    style={{
                        width: '100%', padding: 14, border: 'none', borderRadius: 10,
                        background: loading ? '#ccc' : '#C8102E', color: 'white',
                        fontWeight: 700, fontSize: 15, cursor: loading ? 'not-allowed' : 'pointer',
                    }}
                >
                    {loading ? 'Checking with Flutterwave...' : 'Resync subscription'}
                </button>
            </div>
        </div>
    );
}